import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setUser } from '../../redux/modules/auth';
import { apiUrl, businessName } from '../../utils/consts';
import AppSpinner from '../Extras/AppSpinner/AppSpinner';
import Sidebar from './Sidebar';
import UserProducts from '../UserProducts/UserProducts';
import EditUserProduct from '../EditUserProduct/EditUserProduct';
import Wallet from '../Wallet/Wallet';
import UserBenefits from '../UserBenefits/UserBenefits';
import AdminBenefits from '../AdminBenefits/AdminBenefits';
import AdminProducts from '../AdminProducts/AdminProducts';
import AdminDisbursements from '../AdminDisbursements/AdminDisbursements';
import AdminUsers from '../AdminUsers/AdminUsers';
import UserProfile from '../UserProfile/UserProfile';
import EditUserBenefit from '../EditUserBenefit/EditUserBenefit';
import './styles/dashboard.scss';
import AdminDashboard from '../AdminDashboard/AdminDashboard';
import UserDocuments from '../UserDocuments/UserDocuments';
import UserFamilyMembers from '../UserFamilyMembers/UserFamilyMembers';
import UserBenefitDetail from '../UserBenefitDetail/UserBenefitDetail';
import PayrollDeductions from '../PayrollDeductions/PayrollDeductions';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token,
    user: state.auth.user
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setUser: payload => dispatch(setUser(payload))
  };
}

function ConnectedDashboardComponent(props) {

  const { user } = props;
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    getUserInfo();
  }, []);

  useEffect(() => {
    const pathname = props.location.pathname;

    if (user.nibiBusinessRole === 'ADMIN') {
      if (pathname === '/dashboard/admin/seccion_solidaria') setTab(5);
      else if (pathname === '/dashboard/admin/productos') setTab(6);
      else if (pathname === '/dashboard/admin/desembolsos') setTab(7);
      else if (pathname === '/dashboard/admin/usuarios') setTab(8);
      else if (pathname === '/dashboard/admin/dashboard') setTab(10);
      else if (pathname === '/dashboard/admin/descuentos_nomina') setTab(14);
    }

    if (pathname === '/dashboard/perfil') setTab(0);
    else if (pathname === '/dashboard/productos') setTab(1);
    else if (pathname === '/dashboard/productos/editar') setTab(2);
    else if (pathname === '/dashboard/billetera') setTab(3);
    else if (pathname === '/dashboard/seccion_solidaria') setTab(4);
    else if (pathname === '/dashboard/seccion_solidaria/editar') setTab(9);
    else if (pathname === '/dashboard/documentos') setTab(11);
    else if (!user.nibiBusinessRelatedUserId && pathname === '/dashboard/familia') setTab(12);
    else if (pathname === '/dashboard/seccion_solidaria/ver') setTab(13);

  }, [props.location.pathname]);

  const onClickTab = target => {
    setTab(target);
  };

  const getUserInfo = async () => {
    setLoading(true);

    const userProm = await fetch(`${apiUrl}/users/get/info`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: props.token,
        userId: props.userId,
        businessName
      })
    });

    const userJson = await userProm.json();
    if (userJson.success) props.setUser({ user: userJson.user });

    setLoading(false);
  };

  const viewPanel = (
    <div>
      {
        tab === 0 ? <UserProfile /> :
        tab === 1 ? <UserProducts /> :
        tab === 2 ? <EditUserProduct /> :
        tab === 3 ? <Wallet /> :
        tab === 4 ? <UserBenefits /> :
        tab === 5 ? <AdminBenefits /> :
        tab === 6 ? <AdminProducts /> :
        tab === 7 ? <AdminDisbursements /> :
        tab === 8 ? <AdminUsers /> :
        tab === 9 ? <EditUserBenefit /> :
        tab === 10 ? <AdminDashboard /> :
        tab === 11 ? <UserDocuments /> :
        tab === 12 ? <UserFamilyMembers /> :
        tab === 13 ? <UserBenefitDetail /> :
        tab === 14 ? <PayrollDeductions /> :
        <div></div>
      }
    </div>
  );

  return (
    <div className="dashboard-component">
      {
        loading ?
        <AppSpinner /> :
        <div className="wrapper">
          <Sidebar buttonClick={onClickTab} refresh={getUserInfo} />
          <div id="dashContainer">
            {viewPanel}
          </div>
        </div>
      }
    </div>
  );
}

const DashboardComponent = connect(select, mapDispatchToProps)(ConnectedDashboardComponent);

export default DashboardComponent;
